import { SkeletonText } from '@dev-spendesk/grapes';

import { QueryError } from 'src/core/common/components/QueryError';
import { QuerySuspense } from 'src/core/common/components/QuerySuspense';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useCostCentersQuery } from 'src/core/modules/budgets/apis';

import { CommonSelect, type Option } from './CommonSelect';

export const CostCenterSelect = ({
  selectedValues,
  onSelect,
  mode,
}: {
  selectedValues: { id: string; name: string }[] | undefined | null;
  onSelect: (values: { id: string; name: string }[] | null) => void;
  mode: 'create' | 'edit';
}) => {
  const costCentersQueryState = useCostCentersQuery();
  const { t } = useTranslation('global');

  const baseOptions: Option[] =
    costCentersQueryState.status === 'success'
      ? costCentersQueryState.data.map((costCenter) => ({
          key: costCenter.id,
          label: costCenter.name,
        }))
      : [];

  return (
    <QuerySuspense
      queryState={costCentersQueryState}
      loading={<SkeletonText size="xxl" />}
      fallback={(error) => (
        <QueryError queryError={error} componentType="Callout" />
      )}
    >
      {() => (
        <CommonSelect
          selectedValues={selectedValues}
          onSelect={onSelect}
          baseOptions={baseOptions}
          placeholder={t(
            'approvalWorkflows.dimensions.costCenter.selectACostCenter',
          )}
          dimensionName="costCenter"
          mode={mode}
        />
      )}
    </QuerySuspense>
  );
};
